import React, { useEffect } from "react";
import { Link } from "./link.js";
import { t } from "i18next";
import { Spinner, ProgressBar, Row, Card, Col } from "react-bootstrap";
import moment from "moment";
import Utils from "../../utils/index.js";
import FileInput from "react-fine-uploader/file-input";
import _ from "lodash";
import CircularProgress from '../../pages/BuildAssistant/CircularProgress.js';

export function AddKnowledgeBase({
  multipleFiles,
  sectionRef,
  existingTable,
  tablesData = [],
  filesEndRef,
  uploadProgress,
  config = null,
  tableName = "",
  tablesOptions = "",
  uploader,
  tables = [],
  errorMessage = "",
  deleteFile,
  setExistingTable,
  setTablesOptions,
  handleTableNameChange,
  onClose,
  type = "Builder",
  uploadstatus,
  progress,
  statusUpdate,
  progressVisisble,
  getAssistentId
}) {
  const latestFile = _.sortBy(multipleFiles, "createdAt").reverse();
  const totalSteps = 4;
  const allowedExtensions = config?.allowedTypes
    ? JSON.parse(config.allowedTypes).join(",")
    : "";
  return (
    <div className="inner-body-of-form" ref={sectionRef}>
      <div className="icon-builder">
        <img src="/images/book.svg" alt="Knowledge Base" />
      </div>
      <div className="right-inenr-wrap">
        <div className="heading-box">
          <div className="instruct-title">
            <div className="name-infowrap">
              <span className="name-box">{t("knowledge")}</span>
              <p className="disc-title">{t("buildAssistantpara4")}</p>
            </div>
          </div>
          {/* <Link
            id="t-2"
            title={`${t("knowledgeOverlay1")} ${t("knowledgeOverlay2")}`}
          >
            <img src="/images/questionmark.svg" />
          </Link> */}
          <div className="d-flex aling-items-center gap-5">
            <Link
              id="t-2"
              title={`${t("knowledgeOverlay1")} ${t("knowledgeOverlay2")}`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M10.4996 9.00224C10.6758 8.50136 11.0236 8.079 11.4814 7.80998C11.9391 7.54095 12.4773 7.4426 13.0006 7.53237C13.524 7.62213 13.9986 7.89421 14.3406 8.30041C14.6825 8.70661 14.8697 9.22072 14.8689 9.75168C14.8689 11.2506 12.6205 12 12.6205 12M12.6495 15H12.6595M12.4996 20C17.194 20 20.9996 16.1944 20.9996 11.5C20.9996 6.80558 17.194 3 12.4996 3C7.8052 3 3.99962 6.80558 3.99962 11.5C3.99962 12.45 4.15547 13.3636 4.443 14.2166C4.55119 14.5376 4.60529 14.6981 4.61505 14.8214C4.62469 14.9432 4.6174 15.0286 4.58728 15.1469C4.55677 15.2668 4.48942 15.3915 4.35472 15.6408L2.71906 18.6684C2.48575 19.1002 2.36909 19.3161 2.3952 19.4828C2.41794 19.6279 2.50337 19.7557 2.6288 19.8322C2.7728 19.9201 3.01692 19.8948 3.50517 19.8444L8.62619 19.315C8.78127 19.299 8.85881 19.291 8.92949 19.2937C8.999 19.2963 9.04807 19.3029 9.11586 19.3185C9.18478 19.3344 9.27145 19.3678 9.44478 19.4345C10.3928 19.7998 11.4228 20 12.4996 20Z"
                  stroke="#0061AF"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>
            <span className="close cursor-pointer" onClick={onClose}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M18 6L6 18M6 6L18 18"
                  stroke="#0061AF"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </div>
        </div>
        <div className="chip-wrapper">
          {existingTable
            ? tablesData.data?.map((data) => (
              <div key={data.id} className="chip-bx">
                <span className="icon-xob">
                  <svg
                    width="56"
                    height="56"
                    viewBox="0 0 56 56"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="56" height="56" rx="28" fill="#F2F4F7" />
                    <g opacity="0.08">
                      <rect
                        x="0.375"
                        y="0.375"
                        width="55.25"
                        height="55.25"
                        rx="27.625"
                        stroke="#101828"
                        strokeWidth="0.75"
                      />
                    </g>
                    <path
                      d="M16 24L40 24M24 16L24 40M22.4 16H33.6C35.8402 16 36.9603 16 37.816 16.436C38.5686 16.8195 39.1805 17.4314 39.564 18.184C40 19.0397 40 20.1598 40 22.4V33.6C40 35.8402 40 36.9603 39.564 37.816C39.1805 38.5686 38.5686 39.1805 37.816 39.564C36.9603 40 35.8402 40 33.6 40H22.4C20.1598 40 19.0397 40 18.184 39.564C17.4314 39.1805 16.8195 38.5686 16.436 37.816C16 36.9603 16 35.8402 16 33.6V22.4C16 20.1598 16 19.0397 16.436 18.184C16.8195 17.4314 17.4314 16.8195 18.184 16.436C19.0397 16 20.1598 16 22.4 16Z"
                      stroke="#475467"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <div className="name-file-bx">
                  {data.fileName}
                  <div className="filepathino"></div>
                </div>
              </div>
            ))
            : ""}
        </div>
        <div className="input-wrap-row-wrap">
          {!existingTable && (
            <div className="from-input-wrapper">
              <label htmlFor="name">
                {t("tableKnowledge")}{" "}
                {multipleFiles?.length > 0 && (
                  <span style={{ color: "red" }}>*</span>
                )}
              </label>
              <input
                id="tablename"
                placeholder={t("tableName")}
                className="form-control mb-2"
                value={tableName}
                onChange={handleTableNameChange}
                required={multipleFiles?.length > 0}
                // readOnly={assistant.length > 0 }
                disabled={type == "KnowledgeBase"}
              />
              {errorMessage && (
                <div style={{ color: "red" }}>{errorMessage}</div>
              )}
            </div>
          )}
          {existingTable && (
            <div className="from-input-wrapper">
              <label htmlFor="name">Existing Knowledge Base</label>
              <select
                className="form-select "
                aria-label="Default select example"
                value={tablesOptions}
                onChange={(e) => setTablesOptions(e.target.value)}
              >
                {tables.map((option, id) => (
                  <option key={id} value={option.tableUuid}>
                    {option.tableName}
                  </option>
                ))}
              </select>
            </div>
          )}

          {type != "KnowledgeBase" && !(multipleFiles?.length > 0) ? (
            <span
              className="d-flex gap-2 align-items-center msg-box"
              style={{
                cursor: "pointer",
                // marginTop: "-0.5rem",
                // width: "250px",
              }}
              onClick={() => setExistingTable(!existingTable)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M2.5 7.5L17.5 7.5M7.5 2.5L7.5 17.5M6.5 2.5H13.5C14.9001 2.5 15.6002 2.5 16.135 2.77248C16.6054 3.01217 16.9878 3.39462 17.2275 3.86502C17.5 4.3998 17.5 5.09987 17.5 6.5V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V6.5C2.5 5.09987 2.5 4.3998 2.77248 3.86502C3.01217 3.39462 3.39462 3.01217 3.86502 2.77248C4.3998 2.5 5.09987 2.5 6.5 2.5Z"
                  stroke="#0061AF"
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              {existingTable
                ? "or add a new knowledge"
                : "or add to existing knowledge"}
            </span>
          ) : (
            ""
          )}

          <div className="from-input-wrapper">
            <div className="input-wrap-row-wrap">
              <div className="from-input-wrapper">
                {/* <label htmlFor='name'>Knowledge name</label> */}
                {!existingTable && (
                  <div
                    className="file-uploader"
                    onClick={() => {
                      document.getElementById("fileUploader").click();
                      {
                        !tableName &&
                          document.getElementById("tablename").focus();
                      }
                      getAssistentId()
                    }}
                  >
                    <FileInput
                      uploader={uploader}
                      multiple
                      disabled={latestFile[0]?.status === "pending"}
                      id="fileUploader"
                      accept={allowedExtensions}
                      data-tooltip-id="upload-file-btn"
                      data-tooltip-content={
                        multipleFiles?.length >= config?.maxFiles
                          ? `${t("multipleFilesUpload")} ${config?.maxFiles
                          } ${t("files")}.`
                          : ""
                      }
                      title=""
                      style={{
                        cursor:
                          latestFile[0]?.status === "pending"
                            ? "not-allowed"
                            : "auto",
                      }}
                    >
                      <div
                        aria-disabled={
                          multipleFiles?.length >= config?.maxFiles
                            ? true
                            : false
                        }
                        className={`btn builderbtn mb-2 ${multipleFiles?.length >= config?.maxFiles
                            ? "disabled"
                            : ""
                          }`}
                      ></div>
                    </FileInput>
                    <div
                      className="fil-uplaod-icon"
                    // onClick={handleClick}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                      >
                        <path
                          d="M7.16699 13.3333L10.5003 10M10.5003 10L13.8337 13.3333M10.5003 10V17.5M17.167 13.9524C18.1849 13.1117 18.8337 11.8399 18.8337 10.4167C18.8337 7.88536 16.7816 5.83333 14.2503 5.83333C14.0682 5.83333 13.8979 5.73833 13.8054 5.58145C12.7187 3.73736 10.7124 2.5 8.41699 2.5C4.96521 2.5 2.16699 5.29822 2.16699 8.75C2.16699 10.4718 2.8632 12.0309 3.98945 13.1613"
                          stroke="#475467"
                          strokeWidth="1.66667"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="linktext-upload">
                      <strong>{t("clickToUpload")}</strong>{" "}
                    </div>
                    <div className="infoText">{t("infoTextKb")}</div>
                  </div>
                )}

                <div className="filewrapper mt-3 chip-wrapper">
                  {multipleFiles.map((file, index) => {
                    const message = file.message;

                    return (
                      <Row xs={1} md={1} className="g-4 mb-2" key={index}>
                        <Col>
                          <Card>
                            <Card.Body>
                              <div
                                className="mb-4pt"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "start",
                                }}
                              >
                                <div style={{ display: "flex" }}>
                                  <Card.Title className="carfile-tile h6">
                                    <Link id="t-2" title={`${file?.fileName} `}>
                                      {" "}
                                      <span className="fileinfoname name-span">
                                        {file?.fileName}
                                        {file?.size &&
                                          `(${Utils.formatBytes(
                                            file?.size
                                          )})`}{" "}
                                      </span>
                                    </Link>
                                    <span className="datefile d-block">
                                      {moment(file?.createdAt).format(
                                        "Do MMMM, YYYY HH:mm a"
                                      )}
                                    </span>
                                  </Card.Title>
                                </div>
                                {uploadstatus && file?.status == "N" ? (
                                  <Spinner animation="border" />
                                ) : file?.status == "pending" && !progressVisisble ? (
                                  <span
                                    className="d-flex flex-column gap-2 align-items-end"
                                    style={{ textAlign: "center" }}
                                  >
                                    {/* <Spinner
                                      width="20"
                                      height="20"
                                      animation="border"
                                    /> */}
                                    <div className="d-flex" style={{
                                    flexDirection: file?.status !== "E" && file?.status !== "Y" ? "column" : "row",
                                  }}>
                                    {!file.isProcessed &&
                                        <div class="btn-bxc" className="upload-top" style={{ paddingBottom: '5px' }}><span class="d-flex gap-2 align-items-center">
                                          <CircularProgress currentStep={file.step} totalSteps={totalSteps} />
                                        </span></div>}
                                        
                                      <span
                                        style={{
                                          fontSize: "10px",
                                          lineHeight: "25px",
                                          textAlign: "right",
                                        }}
                                        class="status-ip"
                                      >
                                        {message?.trim() ? message : "File upload successful. Processing initiated..."}
                                      </span>
                                     
                                    </div>
                                  </span>
                                ) : (
                                  <span className="d-flex gap-2 align-items-center" style={{
                                    flexDirection: file?.status !== "E" && file?.status !== "Y" ? "column" : "row",
                                  }}>
                                    {" "}
                                    {file?.status == "Y" && (
                                      <span>
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 16 16"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <rect
                                            x="0.5"
                                            y="0.5"
                                            width="15"
                                            height="15"
                                            rx="7.5"
                                            fill="rgba(18,199,71,1)"
                                          ></rect>
                                          <rect
                                            x="0.5"
                                            y="0.5"
                                            width="15"
                                            height="15"
                                            rx="7.5"
                                            stroke="rgba(18,199,71,1)"
                                          ></rect>
                                          <path
                                            d="M11.3307 5.5L6.7474 10.0833L4.66406 8"
                                            stroke="white"
                                            stroke-width="1.66667"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></path>
                                        </svg>
                                      </span>
                                    )}
                                    {file?.status == "error" && (
                                      <Link
                                        id="t-4"
                                        title={
                                          file?.error?.includes("Error:")
                                            ? file?.error
                                            : "Something went wrong. Please delete the file and try again."
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          fill="red"
                                          className="bi bi-exclamation-triangle-fill"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
                                        </svg>
                                      </Link>
                                    )}
                                    <span className="upload-top gap-2">
                                    {!file.isProcessed &&
                                        <div class="btn-bxc" style={{ paddingLeft: '5px' }}><span class="d-flex gap-2 align-items-center">
                                          <CircularProgress currentStep={file.step} totalSteps={totalSteps} />
                                        </span></div>}
                                    {file?.status == "Y" ||
                                      file?.status == "N" ||
                                      file?.status == "error" ? (
                                      <span
                                        onClick={() => deleteFile(file, index)}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          <path
                                            d="M7.5 2.5H12.5M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5M8.33333 8.75V12.9167M11.6667 8.75V12.9167"
                                            stroke="#B42318"
                                            strokeWidth="1.66667"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                    </span>
                                    {file?.status == "N" && (
                                      <span
                                        style={{
                                          fontSize: "10px",
                                          lineHeight: "12px",
                                        }}
                                         class="status-ip"
                                      >
                                        {" "}
                                        {file.message || `File upload successful. Processing initiated...`}
                                      </span>
                                    )}
                                        {file?.status == "I" && file?.message && (
                                          <span
                                            style={{ fontSize: "10px", background: "#f6e160", borderRadius: '1rem', lineHeight: '25px', padding: '0.3125rem 0.625rem' }}
                                          >
                                            {" "}
                                            {file?.message}
                                          </span>
                                        )}
                                    
                                  </span>
                                )}
                              </div>
                              {/* {
                              (file?.status === 'N'|| file?.status === 'pending') && !file?.isProcessed && (
                                <>
                                    {/* <span
                                      style={{
                                        fontSize: "10px",
                                        lineHeight: "12px",
                                      }}
                                    >
                                      {" "}
                                      {file.message}
                                    </span> */}
                              {/* <div className="d-flex mt-2 gap-2 align-items-center customprogress">
                                    <ProgressBar
                                      now={
                                        file.progress
                                      }
                                    />
                                    <span className="procount">{`${Math.trunc(
                                      file.progress
                                    )}%`}</span>
                                  </div>
                                  </>
                              )
                            } */}

                              {progress && file?.status == "pending" ? (
                                <div className="d-flex mt-2 gap-2 align-items-center customprogress">
                                  <ProgressBar
                                    now={uploadProgress}
                                  //label={`${Math.trunc(uploadProgress)}%`}
                                  />
                                  <span className="procount">{`${Math.trunc(
                                    uploadProgress
                                  )}%`}</span>
                                </div>
                              ) : (
                                // <ProgressBar
                                //   now={uploadProgress}
                                //   label={`${Math.trunc(uploadProgress)}%`}
                                // />
                                ""
                              )}
                            </Card.Body>
                          </Card>
                        </Col>
                      </Row>
                    )
                  })}
                  {multipleFiles.length > 0 &&
                    latestFile?.status !== "pending" ? (
                    <div className="d-flex justify-content-end btn-rfeshs">
                      <Link id="t-1" title="Refresh">
                        {" "}
                        <button
                          onClick={() => statusUpdate()}
                          className="rfresh-btn"
                          disabled={uploadstatus}
                        >
                          {" "}
                          {!uploadstatus ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              class="bi bi-arrow-clockwise"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                              />
                              <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                            </svg>
                          ) : (
                            <Spinner
                              animation="border"
                              style={{ width: "16px", height: "16px" }}
                            />
                          )}
                        </button>{" "}
                      </Link>
                    </div>
                  ) : (
                    ""
                  )}
                  <div ref={filesEndRef} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
